import { useSelector } from 'react-redux';
import { capitalize, Typography } from '@material-ui/core';
import { PermissionActionsNames } from '@constants/permissions';
import { getAllSubmissionGroupListSelector } from '@selectors/submissionGroups';
import { FeaturePermissionEntityInterface } from '@types';
import { PermissionActions } from '@enums';
import { FeaturePermissionItem } from '@components/Pages/DashboardPage/RolesPage/FeaturePermissionItem';

interface Props {
  name: string;
  title?: string;
  description?: string;
  features: FeaturePermissionEntityInterface[];
  externalFeature?: FeaturePermissionEntityInterface;
}

export const FeaturePermissionGroupItem = ({
  features,
  name,
  title,
  description,
  externalFeature,
}: Props) => {
  const allGroups = useSelector(getAllSubmissionGroupListSelector);

  return (
    <div className="feature-item" data-testid="dt-feature-group-permissions">
      <Typography className="feature-item__name">{title || name}</Typography>
      {description && <Typography className="feature-item__description">{description}</Typography>}
      <div className="feature-item__list">
        <div className="feature-item__list feature-row">
          <Typography className="feature-row__header">{`${PermissionActionsNames['view']}:`}</Typography>
          <div>
            {allGroups
              .map((group) => {
                const feature = features.find((feature) => feature.instanceKey === group.id);
                return feature ? feature[PermissionActions.View] && group.name : group.name;
              })
              .filter((groupName: string) => Boolean(groupName))
              .map((groupName: string) => capitalize(groupName))
              .join(', ')}
          </div>
        </div>
        {externalFeature && (
          <FeaturePermissionItem
            feature={externalFeature}
            key={`${externalFeature.name}${externalFeature.instanceKey}`}
            actionsOnly={true}
          />
        )}
      </div>
    </div>
  );
};
